import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatchedMail } from '../../../intefaces/matched-mail.interface';
import { MatchedMailService } from '../../../services/matched-mail.service';
import { StatusMessageService } from '../../../services/status-message.service';

@Component({
  selector: 'app-matched-mails',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './matched-mails.component.html',
  styleUrl: './matched-mails.component.scss'
})
export class MatchedMailsComponent implements OnInit {
  @Input() identifier!: string;

  matchedMails: MatchedMail[] = [];
  isLoading = false;
  isTriggeringSync = false;
  unreadCount = 0;

  constructor(
    private matchedMailService: MatchedMailService,
    private statusMessage: StatusMessageService
  ) {}

  ngOnInit(): void {
    this.loadMatchedMails();
  }

  loadMatchedMails(): void {
    this.isLoading = true;
    this.matchedMailService.getMatchedMails(this.identifier).subscribe({
      next: (mails) => {
        this.matchedMails = mails;
        this.unreadCount = mails.filter(m => m.mail_notification).length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.statusMessage.showStatusMessage('Matched mails could not be loaded!', 'error');
      }
    });
  }

  acknowledgeMail(mail: MatchedMail): void {
    this.matchedMailService.acknowledgeMail(this.identifier, mail.message_id).subscribe({
      next: (updated) => {
        mail.mail_notification = false;
        this.unreadCount = this.matchedMails.filter(m => m.mail_notification).length;
      },
      error: () => {
        this.statusMessage.showStatusMessage('Could not acknowledge mail!', 'error');
      }
    });
  }

  acknowledgeAll(): void {
    const unread = this.matchedMails.filter(m => m.mail_notification);
    unread.forEach(mail => this.acknowledgeMail(mail));
  }

  triggerMailSync(): void {
    this.isTriggeringSync = true;
    this.matchedMailService.triggerMailMatching().subscribe({
      next: () => {
        this.isTriggeringSync = false;
        this.statusMessage.showStatusMessage('Mail scan triggered. New matches will appear shortly.', 'info');
      },
      error: () => {
        this.isTriggeringSync = false;
        this.statusMessage.showStatusMessage('Mail scan could not be triggered!', 'error');
      }
    });
  }
}
